import request from "../utils/request";

export function getSites(perPage = 25, page = 1, extendedMeta) {
    return request.get("sites/pagination", {
        params: {
            pageCount: page,
            perPage: perPage,
            extendedMeta,
        },
    });
}

export function lookupSites(pagination, sorting, search, filters) {
    return request.post("sites/lookup?extendedMeta=true", {
        pagination,
        sorting,
        search,
        filters,
    });
}

export function getSite(id) {
    return request.get(`sites/site/${id}`);
}

export function createSite(data) {
    return request.post("sites/", data);
}

export function deleteSite(siteId) {
    return request.delete(`sites/${siteId}`);
}

export function updateSite(id, data) {
    return request.put(`sites/${id}`, data);
}

export function getSiteBySiteAddress(siteAddress) {
    return request.get(`sites/search/${siteAddress}`);
}

export function getSiteDetail(siteAddress) {
    return request.get(`sites/detail/${siteAddress}`);
}

export function clean() {
    return request.get(`sites/clean`, { timeout: 1000 * 60 });
}

export function checkIntegrationStatus(website) {
    return request.post(`public/sites/check-integration-status`, { website }).then((res) => res.data);
}

export function updateSiteSingleKey(siteId, key, value) {
    return request.post(`sites/${siteId}/update-single-key`, { siteId, key, value });
}
